import React from "react";
import { Link } from 'react-router-dom';

import './Internship.css';
import CourseCard from "../../../pages/CourseCard/CourseCard";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import fullstack from "../../../assets/images/fullstack.png";
import aiml from "../../../assets/images/aindml.webp";
import network from "../../../assets/images/netwrking.jpg";
import exampos from "../../../assets/eduban/exampo.jpg";
// Course data
const courses = [
    {
        title: "Full Stack Web Development",
        description: "Learn front-end, back-end, and database technologies to build modern web applications.",
        image: fullstack,
    },
    {
        title: "Artificial Intelligence & Machine Learning",
        description: "Master the fundamentals of AI and build ML models for real-world applications.",
        image: aiml,
    },
    {
        title: "Networking Essentials",
        description: "Understand network configurations, security, and protocols to manage IT systems.",
        image: network,
    },
];

// Shared Google Form link
const formLink = "https://forms.gle/Y4D739UUQvFwePy18"; // Replace with your actual form link

const Internship = () => {
    const breadcrumbs = [
        { label: "Home", link: "home" },
        { label: "Internship", link: "Internship" },
    ];

    return (
        <>
            {/* Breadcrumb Navigation */}
            <Breadcrumb pageTitle="Internship" breadcrumbs={breadcrumbs} />
  <div className="side-by-side-container intnshipspa">
        <div className="container sidebyside">
            <div className="left-boxes">
                        <h1 className='fp1'>Show Your Talent — <br />
                        Win a Free Internship! </h1>
                        <h5 className="headingin">Neuraltech IT Solutions hosts a monthly Talent Exam to find and nurture top tech talent.</h5>
                <p className="descriptionin">

                            Take our online skill-based exam and win a <strong>Free Internship</strong> at Neuraltech IT Solutions.
                            Top two performers each month work on real-world projects and jumpstart their IT careers!
                </p>
                        <div className="exam-brief">
                            <h5 className="exam-title"> Why Participate?</h5>
                            <ul className="exam-points">
                                <li>🏆 Top 2 scorers win a free internship offer.</li>
                                <li>💻 Work on live client projects with expert mentors.</li>
                                <li>📈 Boost your resume with real-world experience.</li>
                                <li>🕐 One attempt per month — make it count!</li>
                            </ul>
                        </div>
                        <Link to="/login">
                <button className="action-button">Take Test</button>
                   </Link>
            </div>
            <div className="right-boxes">
                <img src={exampos} alt="Sample" className="image" />
            </div>
            </div>
        </div>
            {/* Course List */}
            <div className="course-list container">
                {courses.map((course, index) => (
                    <CourseCard
                        key={index}
                        title={course.title}
                        description={course.description}
                        image={course.image}
                        formLink={formLink} // Pass the shared form link
                    />
                ))}
            </div>
        </>
    );
};

export default Internship;
